import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const VideoContainer = styled.video`
    display: block;
    max-height: 230px;
    max-width: 300px;
    ${({ height }) => `height: ${height};`}
    ${({ width }) => `width: ${width};`}
`
